import { Routes } from '@angular/router';
import { SolutionComponent } from './solution/solution.component';

export const solutionRoutes: Routes = [
  {
    path: 'solutions',
    data: {
      breadcrumb: {}
    },
    children: [
      {
        path: 'create',
        component: SolutionComponent,
        data: {
          type: 'create',
          breadcrumb: {
            bcType: 'Display',
            action: 'Create',
            value: 'Solutions',
            type: 'Solution'
          }
        }
      },
      {
        path: ':solutionId',
        data: {
          breadcrumb: {
            bcType: 'LookUp',
            value: 'solutionId',
            type: 'Solution'
          }
        },
        children: [
          {
            path: 'edit',
            component: SolutionComponent,
            data: {
              type: 'edit',
              breadcrumb: {
                bcType: 'Display',
                action: 'Edit'
              }
            }
          }
        ]
      }
    ]
  },
];
